import { render } from "./CreateSeminarKursusView.vue?vue&type=template&id=2def96ca"
import script from "./CreateSeminarKursusView.vue?vue&type=script&lang=js"
export * from "./CreateSeminarKursusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__